import { useRef, useState } from "react";

const throttle = (callback, delay) => {
  let lastCall = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      callback(...args);
    }
  };
};

const useResizableColumn = () => {
  const tableRef = useRef(null);
  const [columnWidths, setColumnWidths] = useState([]);
  const resizingCol = useRef(null);
  const startX = useRef(0);
  const startsWidth = useRef(0);

  const handleMouseMove = (moveEvent) => {
    const newWidth = startsWidth.current + moveEvent.clientX - startX.current;
    setColumnWidths((prevWidths) => {
      const updatedWidth = [...prevWidths];
      updatedWidth[resizingCol.current] = newWidth;
      return updatedWidth;
    });
  };

  const handleMouseUp = () => {
    document.body.classList.remove("no-select");
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const handleMouseDown = (index, event) => {
    const parentElement = event.target.parentNode;
    const parentWidth = parentElement.offsetWidth;
    resizingCol.current = index;
    startX.current = event.clientX;
    startsWidth.current = columnWidths[index] || parentWidth;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleDoubleClick = (index) => {
    if (tableRef.current) {
      const th = tableRef.current.querySelectorAll("th")[index];
      const cells = Array.from(tableRef.current.querySelectorAll(`td:nth-child(${index + 1})`));
      const maxContentWidth = cells.reduce((maxWidth, cell) => {
        const cellWidth = cell.scrollWidth;
        return Math.max(maxWidth, cellWidth);
      }, th.scrollWidth);

      setColumnWidths((prevWidths) => {
        const newWidths = [...prevWidths];
        newWidths[index] = maxContentWidth + 16; // Add some padding
        return newWidths;
      });
    }
  };

  return { columnWidths, handleMouseDown, tableRef };
};

export default useResizableColumn;
